// extracted by mini-css-extract-plugin
export var form = "_cc-0";